import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MoteUnreachableNew from 'common/images/MoteUnreachableNew';

const UnreachableMark = ({ marginLeft, marginRight }) => {
  const { t } = useTranslation();
  return (
    <span
      style={{ marginLeft, marginRight }}
      title={t('assets.tooltips.unreachableDevices', { defaultValue: 'Asset has unreachable devices.' })}
    >
      <MoteUnreachableNew fill="red" />
    </span>
  );
};

UnreachableMark.propTypes = {
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string
};
UnreachableMark.defaultProps = {
  marginRight: '0px',
  marginLeft: '0px'
};
export default UnreachableMark;
